export default __webpack_public_path__ + "static/media/close-icon1.b3d7b6fa.svg";